import { render, staticRenderFns } from "./QuoteMovements.vue?vue&type=template&id=4f00f80e&scoped=true&"
import script from "./QuoteMovements.vue?vue&type=script&lang=js&"
export * from "./QuoteMovements.vue?vue&type=script&lang=js&"
import style0 from "./QuoteMovements.vue?vue&type=style&index=0&id=4f00f80e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f00f80e",
  null
  
)

export default component.exports